import * as React from "react";
import { forwardRef } from "react";
const SvgSearchCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2.25, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-search-check", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m8 11 2 2 4-4" }), /* @__PURE__ */ React.createElement("circle", { cx: 11, cy: 11, r: 8 }), /* @__PURE__ */ React.createElement("path", { d: "m21 21-4.3-4.3" }));
const ForwardRef = forwardRef(SvgSearchCheck);
export default ForwardRef;
